import { Injectable } from '@angular/core';
import { CognitoService } from '../cognito/cognito.service';

@Injectable({
  providedIn: 'root',
})
export class FactoryService {
  constructor(private cognito: CognitoService) {}
  

  public async defaultHttpHeaders(params: object = {}) {
    return { params: params, headers: await this.cognito.montarCabecalhoAutenticado() };
  }

  public async blobHttpHeaders(params: object = {}) {
    const httpOptions = {
      params: params,
      headers: await this.cognito.montarCabecalhoAutenticado("pdf"),
      responseType: 'blob' as 'blob',
    };
    return httpOptions;

  }

  public async retHttpHeaders(params: object = {}) {
    const httpOptions = {
      params: params,
      headers: await this.cognito.montarCabecalhoAutenticado("pdf"),
    };
    return httpOptions;
  }
  
}
